import { cn } from '@lib/cn'
import { FC } from 'react'
import { MarginBottomProps } from 'styled-system'

type Props = MarginBottomProps & {
  activeIndex: number
  count: number
  className?: string
  variant?: 'animated' | 'static'
  onChangeIndex?: (index: number) => void
}

const Indicators: FC<Props> = ({
  activeIndex,
  count,
  className,
  variant = 'static',
  onChangeIndex,
}) => (
  <div className={cn('my-[30px] flex items-center justify-center gap-3', className)}>
    {Array.from(new Array(count)).map((_, index) => {
      return (
        <button
          type="button"
          data-active={index === activeIndex ? '' : undefined}
          className={cn(
            'flex min-h-[24px] min-w-[24px] cursor-pointer items-center justify-center rounded',
            'focus:outline-none focus:ring-2 focus:ring-rolexGreenAlt',
          )}
          key={index}
          onClick={() => onChangeIndex?.(index)}
          aria-label={`Go to slide ${index + 1}`}
        >
          <div
            data-active={index === activeIndex ? '' : undefined}
            className={cn(
              'h-1 bg-rolexGrey transition-all duration-200 data-[active]:bg-rolexGreenAlt',
              variant === 'animated' && 'w-[20px] data-[active]:w-[50px]',
              variant === 'static' && 'w-[50px]',
            )}
          />
        </button>
      )
    })}
  </div>
)

export default Indicators
